export enum Privacy {
    Secret = 0,
    PrivateInWorkspace = 1,
    PublicInWorkspace = 2,
    Private = 3,
    PublicForUsers = 4,
    Public = 5,
}
